import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  const navGroups = [
    {
      title: 'Company',
      links: [
        { label: 'Home',               to: '/' },
        { label: 'About Us',           to: '/about' },
        { label: 'Check Compensation', to: '/check-compensation' },
      ],
    },
    // {
    //   title: 'Legal',
    //   links: [
    //     { label: 'Privacy Policy',   to: '#' },
    //     { label: 'Terms of Service', to: '#' },
    //     { label: 'Cookie Policy',    to: '#' },
    //   ],
    // },
    {
      title: 'Support',
      links: [
        { label: 'How It Works', to: '/about' },
        // { label: 'FAQ',          to: '#' },
        { label: 'Contact Us',   to: '/contact' },
      ],
    },
  ];

  const socials = [
    { icon: <FaFacebookF />,  href: '#', label: 'Facebook' },
    { icon: <FaTwitter />,    href: '#', label: 'Twitter' },
    { icon: <FaInstagram />,  href: '#', label: 'Instagram' },
    { icon: <FaLinkedinIn />, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="footer">

      {/* ── Main content ── */}
      <div className="footer__main">
        <div className="footer__inner">

          {/* Brand */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
               Claim AirRefund
            </Link>
            <p className="footer__tagline">
              Fighting for passengers' rights since 2010. We hold airlines accountable
              and make sure you receive every dollar you're owed.
            </p>

            <ul className="footer__contact">
              <li><MdEmail /><span>airrefund032@gmail.com</span></li>
              <li><MdPhone /><span>+44 7988 528 652</span></li>
              <li><MdLocationOn /><span>United Kingdom</span></li>
            </ul>

            <div className="footer__socials">
              {socials.map(({ icon, href, label }) => (
                <a key={label} href={href} className="footer__social" aria-label={label}>
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Nav groups */}
          {navGroups.map(({ title, links }) => (
            <div key={title} className="footer__col">
              <h4 className="footer__col-title">{title}</h4>
              <ul>
                {links.map(({ label, to }) => (
                  <li key={label}>
                    <Link to={to}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* CTA */}
          <div className="footer__col footer__cta-col">
            <h4 className="footer__col-title">Ready to claim?</h4>
            <p>Check eligibility in under 5 minutes. Zero upfront cost.</p>
            <Link to="/check-compensation" className="footer__cta-btn">
              Check Compensation 
            </Link>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p>© {year} Claim AirRefund. All rights reserved.</p>
          <div className="footer__bottom-links">
            <a href="#privacy">Privacy</a>
            <a href="#terms">Terms</a>
            <a href="#cookies">Cookies</a>
          </div>
        </div>
      </div>

    </footer>
  );
}